import { useState, type ComponentProps } from 'react';

import { EyeIcon, EyeOffIcon, LockIcon } from '@/components/icons';
import { TextField } from '@/components/ui/TextField';

type PasswordFieldProps = Omit<ComponentProps<typeof TextField>, 'type' | 'icon' | 'trailing'>;

/** Champ mot de passe avec bascule d'affichage accessible au clavier. */
export const PasswordField = (props: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      type={visible ? 'text' : 'password'}
      icon={<LockIcon />}
      trailing={
        <button
          type="button"
          disabled={props.disabled}
          onClick={() => {
            setVisible((current) => !current);
          }}
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          className="text-navy-500 enabled:hover:bg-navy-50 enabled:hover:text-navy-900 focus-visible:bg-accent-50 focus-visible:text-accent-700 focus-visible:ring-accent-700/25 grid size-8 cursor-pointer place-items-center rounded-md text-lg transition-colors duration-200 focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed motion-reduce:transition-none"
        >
          {visible ? <EyeIcon /> : <EyeOffIcon />}
        </button>
      }
      {...props}
    />
  );
};
